module.exports = {
  width: 120,
  height: 90,
};
